module.exports = __webpack_public_path__ + "assets/img/role-active-1.0fdb472e.png";